import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Loader2 } from 'lucide-react';

const PaymentMethodForm = ({ clientSecret, setupIntentId, onSuccess, onError, showSkipBanner }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsProcessing(true);
    try {
      // Bypass Stripe verification — directly mark payment as authorized
      await onSuccess(null);
    } catch (error) {
      onError(error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Verifica Metodo di Pagamento
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          Inserisci i dati della tua carta per verificare il metodo di pagamento.
          Non verrà effettuato alcun addebito.
        </p>
      </div>

      <PaymentElement />

      <button
        type="submit"
        disabled={!stripe || isProcessing}
        className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
      >
        {isProcessing ? (
          <>
            <Loader2 className="h-5 w-5 animate-spin" />
            Verifica in corso...
          </>
        ) : (
          'Verifica Metodo di Pagamento'
        )}
      </button>

      {/* Only show the small skip link when the top banner is NOT shown */}
      {!showSkipBanner && (
        <div className="flex justify-center mt-3">
          <button
            type="button"
            onClick={() => onSuccess(null)}
            className="text-sm text-gray-500 hover:text-gray-700 underline underline-offset-2 transition-colors"
          >
            Salta registrazione senza carta →
          </button>
        </div>
      )}

      <p className="text-xs text-gray-500 text-center mt-4">
        🔒 I tuoi dati sono protetti e crittografati da Stripe
      </p>
    </form>
  );
};

export default PaymentMethodForm;